module.exports = __webpack_public_path__ + "static/media/menu_group_list.294f73ab.png";